// X renders the original posts and media. Static excerpts remain readable if
// JavaScript, the platform or an individual post is unavailable.
function $239f82ec27f82f7f$export$3d0c6c3e1d074af0(root = document) {
    const posts = root.querySelectorAll('.twitter-tweet');
    if (!posts.length) return;
    let requested = false;
    const load = ()=>{
        if (requested) return;
        requested = true;
        const script = root.createElement('script');
        script.id = 'editorial-twitter-widgets';
        script.async = true;
        script.src = 'https://platform.twitter.com/widgets.js';
        root.head.append(script);
    };
    if (typeof IntersectionObserver !== 'function') {
        load();
        return;
    }
    const observer = new IntersectionObserver((entries)=>{
        if (!entries.some((entry)=>entry.isIntersecting)) return;
        observer.disconnect();
        load();
    }, {
        rootMargin: '600px 0px'
    });
    posts.forEach((post)=>observer.observe(post));
}
$239f82ec27f82f7f$export$3d0c6c3e1d074af0();


//# sourceMappingURL=blog.f2007c9d.js.map
